export default {
  namespaced: true,
  // 储存数据
  state: {
    userinfo: {}, // 个人信息
  },
  mutations: {
    // 个人数据的写入
    setUserInfo(state,data){
        state.userinfo = data
    }
  },
  
};



//////////////////
// WEBPACK FOOTER
// ./store/modules/user.js
// module id = null
// module chunks = 